// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"44":"4b9cf3bd","56":"43918ca0","68":"580f0935","191":"d62da591","260":"6aaffb40","485":"4f806d18","588":"38561e53","783":"4846e6e3","908":"c44356b0","954":"8cc121de"}[chunkId] + ".chunk.css";
};